import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async copyRole(id, name, confirmedAssignmentIds) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/admin/roles/${id}/copy`, { name, confirmedAssignmentIds });
    } catch (error) {
      getUxStore().setError("Fehler beim Kopieren. Bitte Quelle und Berechtigungen erneut prüfen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getRoles() {
    try {
      getUxStore().startLoading();
      return await apiClient.get("/admin/roles");
    } catch (error) {
      console.error("Error in AdminRoleService.getRoles:", error);
      getUxStore().setError("Fehler beim Laden der Rollen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async createRole(name, description = null) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/admin/roles", { name, description });
    } catch (error) {
      console.error("Error in AdminRoleService.createRole:", error);
      getUxStore().setError("Fehler beim Erstellen der Rolle.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async deleteRole(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.delete(`/admin/roles/${id}`);
    } catch (error) {
      console.error("Error in AdminRoleService.deleteRole:", error);
      getUxStore().setError("Fehler beim Löschen der Rolle.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getPermissions() {
    try {
      getUxStore().startLoading();
      return await apiClient.get("/admin/permissions");
    } catch (error) {
      console.error("Error in AdminRoleService.getPermissions:", error);
      getUxStore().setError("Fehler beim Laden der Berechtigungen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getRolePermissions(roleId) {
    try {
      getUxStore().startLoading();
      return await apiClient.get(`/admin/roles/${roleId}/permissions`);
    } catch (error) {
      console.error("Error in AdminRoleService.getRolePermissions:", error);
      getUxStore().setError("Fehler beim Laden der Rollen-Berechtigungen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async setRolePermissions(roleId, permissionIds) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/admin/roles/${roleId}/permissions`, { ids: permissionIds || [] });
    } catch (error) {
      console.error("Error in AdminRoleService.setRolePermissions:", error);
      getUxStore().setError("Fehler beim Speichern der Rollen-Berechtigungen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
